module.exports = __webpack_public_path__ + "img/ts14.ae32a4c1.png";